import { useRef } from 'react';
import { EMAIL_PROPERTY, USER_ID_PROPERTY, USER_OBJECT_TYPE_ID, IS_VIRTUAL_USER, JITA_PROPERTY, IS_BOT_PROPERTY, IS_APP_SERVICE_ACCOUNT, FIRST_NAME_PROPERTY, LAST_NAME_PROPERTY, ACCESS_PROPERTY, NAME_PROPERTY } from '../constants/CrmProperties';
import CrmSearchAPI from '../api/CrmSearchApi';
import UsersSearchApi from '../api/UsersSearchApi';
export const defaultFilters = [{
  operator: 'NEQ',
  property: JITA_PROPERTY,
  value: 'true'
}, {
  operator: 'NEQ',
  property: IS_BOT_PROPERTY,
  value: 'true'
}, {
  operator: 'NEQ',
  property: IS_VIRTUAL_USER,
  value: 'true'
}, {
  operator: 'NEQ',
  property: IS_APP_SERVICE_ACCOUNT,
  value: 'true'
}];
function usePaginatedUsers(pageSize = 100, makeOptions) {
  const emailCache = useRef({});
  function loadOptions(input, callback, pagination = {
    offset: 0
  }) {
    CrmSearchAPI.search({
      objectTypeId: USER_OBJECT_TYPE_ID,
      query: input,
      count: pageSize,
      offset: pagination.offset,
      requestOptions: {
        includeAllProperties: true,
        allPropertiesFetchMode: 'latest_version'
      },
      filterGroups: [{
        filters: [...defaultFilters]
      }],
      sorts: [{
        property: NAME_PROPERTY,
        order: 'ASC'
      }]
    }).then(response => {
      const {
        hasMore,
        results,
        total
      } = response;
      const users = results.map(({
        properties
      }) => {
        const userId = Number(properties[USER_ID_PROPERTY].value);
        const userFirstName = properties[FIRST_NAME_PROPERTY] && properties[FIRST_NAME_PROPERTY].value;
        const userLastName = properties[LAST_NAME_PROPERTY] && properties[LAST_NAME_PROPERTY].value;
        const userEmail = properties[EMAIL_PROPERTY].value;
        const isSuperAdmin = Boolean(properties[ACCESS_PROPERTY].value === 'super_admin');
        emailCache.current[userId] = userEmail;
        return {
          firstName: userFirstName,
          lastName: userLastName,
          email: userEmail,
          id: userId,
          isSuperAdmin
        };
      });
      const options = makeOptions ? makeOptions(users) : users;
      callback(null, {
        options,
        pagination: {
          hasMore,
          total,
          offset: pagination.offset + (hasMore ? pageSize : 0)
        }
      });
    }).catch(error => callback(error));
  }
  function bulkFetchUsers(userIds, includeDeactivatedUsers = false) {
    UsersSearchApi.searchUsers({
      limit: userIds.length,
      mustMatchUserIds: userIds
    }, includeDeactivatedUsers).then(response => {
      const {
        results
      } = response;
      results.forEach(user => {
        const userId = user.user_id;
        const userEmail = user.email;
        emailCache.current[userId] = userEmail;
      });
    }).catch(() => {});
  }
  return {
    loadOptions,
    bulkFetchUsers,
    emailCache: emailCache.current
  };
}
export default usePaginatedUsers;